import React from "react";
import { Link } from "react-router-dom";

import "./Upgrade.css";

const Upgrade = () => {
  return (
    <div className="upgrade-section">
      <div className="upgrade-content">             
        <span className="item1">TO ACCESS OUR AMAZING LEARNING RESOURCES,</span>
        <h1>PLEASE UPGRADE YOUR ACCOUNT</h1>
        <h2><Link to="/contactus" >CONTACT</Link> OUR SUPPORT LEARN TO UNLOCK ACCESS AND START LEARNING.</h2>
      </div>
    </div>
  );
};

export default Upgrade;